import { render, staticRenderFns } from "./UpNumberinput.vue?vue&type=template&id=66206033&scoped=true"
import script from "./UpNumberinput.vue?vue&type=script&lang=js"
export * from "./UpNumberinput.vue?vue&type=script&lang=js"
import style0 from "./UpNumberinput.vue?vue&type=style&index=0&id=66206033&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66206033",
  null
  
)

export default component.exports